import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Button, Divider, Message } from "semantic-ui-react";

import SearchParams from "simplydo/core/searchParams";

const LoginError = () => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const params = new SearchParams(window.location.search);
    setErrorMessage(params.get("message") || "");
  }, []);

  return (
    <div>
      <h1>{t("entry.login.title")}</h1>
      <Divider />
      <p>{t("entry.login.error.info")}</p>
      {errorMessage && <Message color="orange">{errorMessage}.</Message>}
      <Button
        style={{ float: "right" }}
        primary
        as={Link}
        to="/"
        content={t("generic.close")}
      />
    </div>
  );
};

export default LoginError;
